export const isDev =
    !!import.meta.hot || window.origin === 'http://localhost:6006' || process.env.BUILDMODE === 'development'
